module.exports = __webpack_public_path__ + "assets/default-album.7f75ec01.svg";